export default {"src":"/_next/static/media/logo-dealerhub.a4b0ebd9.svg","height":33,"width":272};